"use client";

import _defineProperty from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["id", "htmlFor", "passive"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import R, { createContext as k, useContext as h, useMemo as T, useState as D } from "react";
import { useEvent as v } from '../../hooks/use-event.js';
import { useId as _ } from '../../hooks/use-id.js';
import { useIsoMorphicEffect as A } from '../../hooks/use-iso-morphic-effect.js';
import { useSyncRefs as B } from '../../hooks/use-sync-refs.js';
import { useDisabled as F } from '../../internal/disabled.js';
import { useProvidedId as S } from '../../internal/id.js';
import { forwardRefWithAs as M, useRender as H } from '../../utils/render.js';
var c = k(null);
c.displayName = "LabelContext";
function P() {
  var r = h(c);
  if (r === null) {
    var l = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(l, P), l;
  }
  return r;
}
function I(r) {
  var a, e, o;
  var l = (e = (a = h(c)) == null ? void 0 : a.value) != null ? e : void 0;
  return ((o = r == null ? void 0 : r.length) != null ? o : 0) > 0 ? [l].concat(_toConsumableArray(r)).filter(Boolean).join(" ") : l;
}
function K() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$inherit = _ref.inherit,
    r = _ref$inherit === void 0 ? !1 : _ref$inherit;
  var l = I(),
    _D = D([]),
    _D2 = _slicedToArray(_D, 2),
    a = _D2[0],
    e = _D2[1],
    o = r ? [l].concat(_toConsumableArray(a)).filter(Boolean) : a;
  return [o.length > 0 ? o.join(" ") : void 0, T(function () {
    return function (t) {
      var s = v(function (i) {
          return e(function (p) {
            return [].concat(_toConsumableArray(p), [i]);
          }), function () {
            return e(function (p) {
              var u = p.slice(),
                d = u.indexOf(i);
              return d !== -1 && u.splice(d, 1), u;
            });
          };
        }),
        m = T(function () {
          return {
            register: s,
            slot: t.slot,
            name: t.name,
            props: t.props,
            value: t.value
          };
        }, [s, t.slot, t.name, t.props, t.value]);
      return R.createElement(c.Provider, {
        value: m
      }, t.children);
    };
  }, [e])];
}
var N = "label";
function G(r, l) {
  var y;
  var a = _(),
    e = P(),
    o = S(),
    g = F(),
    _r$id = r.id,
    t = _r$id === void 0 ? "headlessui-label-".concat(a) : _r$id,
    _r$htmlFor = r.htmlFor,
    s = _r$htmlFor === void 0 ? o != null ? o : (y = e.props) == null ? void 0 : y.htmlFor : _r$htmlFor,
    _r$passive = r.passive,
    m = _r$passive === void 0 ? !1 : _r$passive,
    i = _objectWithoutProperties(r, _excluded),
    p = B(l);
  A(function () {
    return e.register(t);
  }, [t, e.register]);
  var u = v(function (L) {
      var b = L.currentTarget;
      if (b instanceof HTMLLabelElement && L.preventDefault(), e.props && "onClick" in e.props && typeof e.props.onClick == "function" && e.props.onClick(L), b instanceof HTMLLabelElement) {
        var n = document.getElementById(b.htmlFor);
        if (n) {
          var E = n.getAttribute("disabled");
          if (E === "true" || E === "") return;
          var x = n.getAttribute("aria-disabled");
          if (x === "true" || x === "") return;
          (n instanceof HTMLInputElement && (n.type === "radio" || n.type === "checkbox") || n.role === "radio" || n.role === "checkbox" || n.role === "switch") && n.click(), n.focus({
            preventScroll: !0
          });
        }
      }
    }),
    d = g || !1,
    C = T(function () {
      return _objectSpread(_objectSpread({}, e.slot), {}, {
        disabled: d
      });
    }, [e.slot, d]),
    f = _objectSpread(_objectSpread({
      ref: p
    }, e.props), {}, {
      id: t,
      htmlFor: s,
      onClick: u
    });
  return m && ("onClick" in f && (delete f.htmlFor, delete f.onClick), "onClick" in i && delete i.onClick), H()({
    ourProps: f,
    theirProps: i,
    slot: C,
    defaultTag: s ? N : "div",
    name: e.name || "Label"
  });
}
var U = M(G),
  Q = Object.assign(U, {});
export { Q as Label, P as useLabelContext, I as useLabelledBy, K as useLabels };